(function ($) {

   $(document).ready(function () {
      DVSubMenuHandle();
      DVSubMenuSlideHandle();

      if (window.innerWidth < 1024) return;
      $('li.menu-item-has-children.menu-depth-0').hover(
         function () {
            $('body').addClass('menu-hover-active');
         },
         function () {
            $('body').removeClass('menu-hover-active');
         }
      );
   });

   const DVSubMenuHandle = () => {
      if (window.innerWidth > 1024) return;

      $('.header-nav-mobile .menu-depth-0 > a').append('<span class="handle-sub-depth-0"></span>');
      $('.header-nav-mobile .sub-menu .menu-item.menu-item-has-children').append('<span class="handle-sub"></span>');

      $('.header-nav-mobile .sub-menu').on('click', '.handle-sub', function (e) {
         e.preventDefault();
         e.stopPropagation();

         let el = $(this).closest('.menu-item.menu-item-has-children');
         $(el).children('.sub-menu').slideToggle();
         $(el).children('.handle-sub').toggleClass('active');
      })
   };

   const DVSubMenuSlideHandle = () => {
      if (window.innerWidth > 1024) return;

      $('.header-nav-mobile #main-nav').on('click', 'li.menu-item-has-children.menu-depth-0 .nav-link', function (e) {
         const href = $(this).attr('href');
         const $li = $(this).closest('.menu-depth-0');
         if ($(e.target).hasClass('handle-sub-depth-0')) {
            e.preventDefault();

            if ($li.hasClass('active')) {
               $li.removeClass('active');
            } else {
               $('#main-nav li.menu-depth-0').removeClass('active');
               $li.addClass('active');
            }

            return;
         }

         if (href && href !== '#') {
            return;
         }

         e.preventDefault();

         if ($li.hasClass('active')) {
            $li.removeClass('active');
         } else {
            $('#main-nav li.menu-depth-0').removeClass('active');
            $li.addClass('active');
         }
      });

      $('.header-nav-mobile #main-nav').on('click', 'li.menu-back, li.menu-left-col', function (e) {
         e.preventDefault();
         $(this).parents('.menu-depth-0').removeClass('active');
      })
   };
})(jQuery);